/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin } from '../main';
import { WidgetElements } from '../elements/widget-elements-base';
import { iam } from '../iam';

export class EnrollChoicesWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override localize() {
    iamLogin.localizeElement('sub-header', 'mfaEnrollSubhead');
  }

  public override initialize() {
    // login.html's mfa enrollment screen (password entry was successful but the user needs to set up mfa)
    if (iam.settings.debug) console.log('initializing mfa enrollment widget');
    iam.settings.deprecatedFactors?.forEach(factor => {
      this.elements.getMfaEnrollmentFactorTile(factor).style.display = 'none';
    });
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    // pull text from okta's hidden title and subtitle and stick it in our title and explanation elements
    setTimeout(() => {
      // okta's header doesn't seem to update synchronously, but asynchronously it seems to work
      document.getElementById('sub-header').textContent = this.elements.getFormHead().textContent;
      document.getElementById('explanation').textContent = this.elements.getFormSubtitle().textContent;
    });
    // change the widget's text for google auth to our generic otp text on the choose factor screen
    iamLogin.registerLocalizationCallback(() => {
      const otpApp = document.querySelector('li[data-se=GOOGLE_AUTH]');
      if (otpApp) {
        iamLogin.localizeElement(otpApp.querySelector('.enroll-factor-description h3'), 'factor-totp-auth');
        iamLogin.localizeElement(otpApp.querySelector('.enroll-factor-description p'), 'otpAppDescription');
      }
    }, true, true);
    // hitting 'Enter' on the factor choice anchor tag buttons results in an inadvertent submit on the widget context that follows, and thus Okta warns "We found some errors. Please review the form and make corrections."
    // capture and swallow the enter key to work around it. perform a click on key up, because key up is the troublesome part for the widget context that follows.
    document.querySelectorAll<HTMLAnchorElement>('.enroll-factor-list .enroll-factor-button a').forEach(button => button.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
      }
    }));
    document.querySelectorAll<HTMLAnchorElement>('.enroll-factor-list .enroll-factor-button a').forEach(button => button.addEventListener('keyup', (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        button.click();
        e.preventDefault();
        e.stopPropagation();
      }
    }));
    // show explanation and footer
    iamLogin.page.showCommonFields(['explanation', 'post-okta']);
    iamLogin.page.initializeCommon();
  }

  public override get wide() {
    return true;
  }
}
